import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
import { useControllable } from "../../lib/useControllable.js";
import { Input } from "../Input/Input.js";
import { FormField } from "../FormField/FormField.js";
/* empty css                  */
import { useEffect, useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/TypeToConfirm/TypeToConfirm.tsx
/**
* A field for a destructive action's confirmation: the action stays disabled until the
* phrase is typed exactly (Delete upload: "DELETE"; Clear pending pay: "CLEAR").
* A match is shown with a check and announced; a typo that can't become the phrase
* shows an error.
*/
function TypeToConfirm({ phrase, value: valueProp, defaultValue = "", onValueChange, onMatchChange, label = `Type ${phrase} to confirm`, hint, caseSensitive = true, mismatchMessage = `Doesn't match ${phrase}`, matchedMessage = `${phrase} typed. You can continue.`, className, ...rest }) {
	const [value, setValue] = useControllable(valueProp, defaultValue, onValueChange);
	const normalise = (text) => caseSensitive ? text : text.toLowerCase();
	const typed = normalise(value.trim());
	const target = normalise(phrase);
	const matched = typed === target;
	const mismatch = typed !== "" && !target.startsWith(typed);
	const reported = useRef(matched);
	useEffect(() => {
		if (reported.current === matched) return;
		reported.current = matched;
		onMatchChange?.(matched);
	}, [matched, onMatchChange]);
	return /* @__PURE__ */ jsxs("div", {
		className: cx("ds-type-to-confirm", matched && "ds-type-to-confirm--matched", className),
		children: [/* @__PURE__ */ jsx(FormField, {
			label,
			hint,
			error: mismatch ? mismatchMessage : void 0,
			children: /* @__PURE__ */ jsx(Input, {
				...rest,
				value,
				onChange: (event) => setValue(event.target.value),
				placeholder: rest.placeholder ?? phrase,
				autoComplete: "off",
				autoCorrect: "off",
				autoCapitalize: "off",
				spellCheck: false,
				trailing: matched ? /* @__PURE__ */ jsx("span", {
					className: "ds-type-to-confirm__check",
					"aria-hidden": "true",
					children: /* @__PURE__ */ jsx(Icon, { name: "check" })
				}) : void 0
			})
		}), /* @__PURE__ */ jsx("span", {
			className: "ds-type-to-confirm__status",
			role: "status",
			children: matched ? matchedMessage : ""
		})]
	});
}
//#endregion
export { TypeToConfirm };

//# sourceMappingURL=TypeToConfirm.js.map